import React, { Component } from 'react'
import Slider from "react-slick";
import { sliderSettings } from './view360config';
import AtomicComponent from '../../AtomicComponents/AtomicComponents';
import {Card} from 'react-bootstrap'
import Styles from '../../Css/View360/View360.module.css'
//redux
import {connect} from 'react-redux'

class View360Slider extends Component {

    constructor(props){
        super(props);

        this.state = {
            modalList: new Map(),
            modalListKeys : [],
            goToSlide: 0,
            
        };
        this.sliderRef = React.createRef()
    }

    async componentDidMount(){
        sliderSettings.nextArrow = <AtomicComponent.SampleNextArrow 
                                        customClassName="slider-next slider-next-arrow" 
                                        customStyle={{ cursor:"pointer", fontSize:'50px', position: 'absolute',right: 0,top: '40%'}}
                                        arrowIconClass="fa fa-caret-right"
                                    />;

        sliderSettings.prevArrow = <AtomicComponent.SamplePrevArrow 
                                        customClassName="slider-prev slider-prev-arrow" 
                                        customStyle={{ cursor:"pointer", fontSize:'50px', position: 'absolute',left: 0,top: '40%'}} 
                                        arrowIconClass="fa fa-caret-left"
                                    />


        await this.setState({...this.state, modalList: this.props.modalList, modalListKeys:[...this.props.modalList.keys()], goToSlide: this.props.goToSlide })

        if(this.sliderRef){
            this.sliderRef.slickGoTo(this.props.goToSlide);
        }
    }


    /**
     * Show modal on button click
     * @param {*} e 
     * @returns 
     */
     hotSpotModelViewBtnClick = (url)=>{
        try {
            if(!url) return;
            window.open(url);
        } catch (error) {
            //console.log(error)
        }
    }


    render() {
        return (
            <div className={[Styles['card-custom'],'col-md-12 p-0'].join(' ')}>
                <span>
                    <i onClick={()=>this.props.hideModal()} className={[Styles['card-custom-close'],'fa','fa-times'].join(' ')}  aria-hidden="true"></i>
                </span>
                <Slider {...sliderSettings}

                    className={[Styles['slick-slider-custom'],'col-md-12'].join(' ')}
                    // style={{display:"flex"}} 
                    // beforeChange = {(oldSlideIndex,newSlideIndex)=>this.handleBeforeChangeSlider(oldSlideIndex, newSlideIndex)}
                    // afterChange = {(index)=>this.handleAfterChangeSlide({index})}
                    // onInit = {()=>this.handleAfterChangeSlide(0)}
                    ref={slider => (this.sliderRef = slider)}
                >
                    {
                        this.state.modalListKeys.length ? this.state.modalListKeys.map(hotSpotKey=>{
                            return (
                                <Card className={[Styles['card-container-custom']]} key={`${hotSpotKey}_view360`} > 
                                <div className={[Styles['slick-contents-container']]} >
                                    {
                                        this.state.modalList.get(hotSpotKey).closeUpURL ? (
                                            <Card.Img variant="top" src={this.state.modalList.get(hotSpotKey).closeUpURL} alt=""/>
                                        ):null
                                    }
                                    <Card.Body className={[Styles['custom-card-body']]}>
                                        <div>
                                            <Card.Title className={[Styles['card-text-custom']]}>
                                                <h4>{ this.state.modalList.get(hotSpotKey).title ? this.state.modalList.get(hotSpotKey).title : ('No Title Found')}</h4>                                                    
                                            </Card.Title>
                                            <Card.Text className={[Styles['card-title-custom']]}>
                                                {
                                                    this.state.modalList.get(hotSpotKey).desc ? 
                                                        `${this.state.modalList.get(hotSpotKey).desc}`:
                                                        null
                                                }             
                                            </Card.Text>
                                        </div>
                                        <span>
                                            {
                                                this.state.modalList.get(hotSpotKey).url ? 
                                                    (<button onClick={()=>this.hotSpotModelViewBtnClick(this.state.modalList.get(hotSpotKey).url)}>
                                                        View
                                                    </button>) : 
                                                    (null)
                                            }
                                        </span>
                                    </Card.Body>
                                </div>
                                </Card>
                            )
                        }) : null
                    }
                </Slider>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps)=>{
    //console.log(state.view360Reducer)
    return{
        hotSpotMapObj : state.view360Reducer.hotSpotMapObj,
    }
}


export default connect(mapStateToProps, null)(View360Slider);
